module.exports = __webpack_public_path__ + "static/img/leijiyouli.fbf0fc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/2020/pc/leijiyouli.png
// module id = oeu0
// module chunks = 69